module.exports = __webpack_public_path__ + "static/equipment-fire-truck-ee631548e6126f18909356cb08f49bbb.jpg";